import Utils from '../utils/Utils'

// https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
const isTouchDevice = () => {
    return (
        'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    )
}

export default {
    // default values
    deviceOs: 'other',
    deviceType: 'other',
    mobileMode: Utils.mobileCheck(),
    isTouch: isTouchDevice(),

    initDeviceParams() {
        const userAgent = window.navigator.userAgent

        const ipad = !!userAgent.match(/iPad/i)
        const iphone = !!userAgent.match(/iPhone/i)

        if (ipad || iphone) {
            this.deviceOs = 'ios'

            const ratio = window.devicePixelRatio || 1

            const screen = {
                width: window.screen.width * ratio,
                height: window.screen.height * ratio
            }

            if (iphone) {
                this.deviceType =
                    (screen.width === 1125 && screen.height === 2436) ||
                    (screen.height === 1125 && screen.width === 2436)
                        ? 'iphonex'
                        : 'iphone'
            } else if (ipad) {
                this.deviceType =
                    (screen.width === 2048 && screen.height === 2732) ||
                    (screen.height === 2048 && screen.width === 2732)
                        ? 'ipadpro'
                        : 'ipad'
            }
        }
    }
}
